module.exports = __webpack_public_path__ + "static/app-icon-cta@2x-b8a798b151eee438c3fb473c9498edb2.png";